module.exports = __webpack_public_path__ + "img/list_Portrait_02.808d23fd.jpeg";